import { useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useUpdateEffect } from 'react-use'
import { useRecoilState, useRecoilValue } from 'recoil'

import defaultWhiteBoardImg from '@/assets/images/defaultWhiteBoard.png'
import microphoneImg from '@/assets/images/mic-min.png'
import microphone1Img from '@/assets/images/mic-min1.png'
import useGetRecoilValue from '@/hooks/useGetRecoilValue'
import { penStateState, viewPicIdState } from '@/store/courseware'
import {
  audioLiveState,
  bigTeaAScreenState,
  BigWin,
  bigWinState,
  correctionState,
  justUserState,
  paramsState,
  restState,
  roomWindowScaleState,
  syncStateState,
  videoLiveTeaState,
  WinTeaId,
  WinTeaName
} from '@/store/room'
import { Board, Conf, Lines } from '@/utils/board'
import { MediaType, RemoteUser } from '@/utils/rtc'
import { Network, networkQualityEnum, VolumeType } from '@/utils/rtc/agora'

import { roomEvent, rtcClient, rtmClient } from '../../../..'
import NetWork from '../../../Network'
import { position, screenPosition } from '../..'

export const viceTeacherVideoBoard = new Board()

export interface Win {
  index: BigWin
  id: WinTeaId
  board: Board
}

export const idDiffName: { [key: string]: WinTeaId } = {
  // '10': 'mainTeacher',
  // '12': 'justTeacher',
  '11': 'viceTeacher'
}

export default function Index() {
  const timer = useRef<any>(null)
  const [correction, setCorrection] = useRecoilState(correctionState)
  const [justUser, setJustUser] = useRecoilState(justUserState)
  const [localJustStatus, setLocalJustStatus] = useState(false)
  const [volumeLevel, setVolumeLevel] = useState<WinTeaName>({
    mainTeacher: 0,
    viceTeacher: 0,
    justTeacher: 0
  }) // 0 ~ 100
  const [netWorkLevel, setNetWorkLevel] = useState<WinTeaName>({
    mainTeacher: 0,
    viceTeacher: 0,
    justTeacher: 0
  }) // 0 ~ 3
  const [params, getParams] = useGetRecoilValue(paramsState)
  const [bigWin, setBigWin] = useRecoilState(bigWinState)
  const [videoLiveTea, setVideoLiveTea] = useRecoilState(videoLiveTeaState)
  const [audioLive, setAudioLive] = useRecoilState(audioLiveState)
  const [syncState, setSyncState] = useRecoilState(syncStateState)
  const [viewPicId, setViewPicId] = useRecoilState(viewPicIdState)
  const [roomWindowScale, setRoomWindowScale] = useRecoilState(roomWindowScaleState)

  const [draw, setDraw] = useState({
    mainTeacher: 0,
    justTeacher: 0,
    viceTeacher: 0
  })
  const winRef = useRef<Win[]>([
    // { index: 2, id: 'mainTeacher', board: mainTeacherVideoBoard },
    // { index: 2, id: 'justTeacher', board: justTeacherVideoBoard },
    { index: 2, id: 'viceTeacher', board: viceTeacherVideoBoard }
  ])
  const rest = useRecoilValue(restState)
  const penState = useRecoilValue(penStateState)
  const bigTeaAScreen = useRecoilValue(bigTeaAScreenState)

  useEffect(() => {
    // 远端和本地视频
    rtcClient.on('user-published', play)
    rtcClient.on('user-unpublished', unplay)
    // 麦震、网络
    rtcClient.on('volume-indicator', volumeIndicator)
    rtcClient.on('network-quality', networkQuality)
    // 视频白板画线
    // mainTeacherVideoBoard.on('emitArtDrawLine', emitArtDrawLine)
    // justTeacherVideoBoard.on('emitArtDrawLine', emitArtDrawLine)
    viceTeacherVideoBoard.on('emitArtDrawLine', emitArtDrawLine)
    // 视频白板配置更新
    // mainTeacherVideoBoard.on('conf', (conf) => boardConf(conf, 'mainTeacher'))
    // justTeacherVideoBoard.on('conf', (conf) => boardConf(conf, 'justTeacher'))
    viceTeacherVideoBoard.on('conf', (conf) => boardConf(conf, 'viceTeacher'))

    // 注册白板
    // console.log(JSON.stringify(winRef.current))
    winRef.current.forEach((v, i) => {
      const ele = document.querySelector(`#videoBoard_${v.id}`)
      v.board.create(ele as unknown as HTMLDivElement)
      let win = ''
      // if (v.id === 'mainTeacher') win = params.mainTeacherId
      // if (v.id === 'justTeacher') win = params.justTeacherId
      if (v.id === 'viceTeacher') win = params.viceTeacherId
      v.board.init({
        windowId: win,
        url: defaultWhiteBoardImg
      })
    })

    return () => {
      rtcClient.removeListener('user-published', play)
      rtcClient.removeListener('user-unpublished', unplay)

      rtcClient.removeListener('volume-indicator', volumeIndicator)
      rtcClient.removeListener('network-quality', networkQuality)

      // mainTeacherVideoBoard.removeListener('emitArtDrawLine', emitArtDrawLine)
      // justTeacherVideoBoard.removeListener('emitArtDrawLine', emitArtDrawLine)
      viceTeacherVideoBoard.removeListener('emitArtDrawLine', emitArtDrawLine)

      // mainTeacherVideoBoard.removeListener('conf', boardConf)
      // justTeacherVideoBoard.removeListener('conf', boardConf)
      viceTeacherVideoBoard.removeListener('conf', boardConf)

      timer.current && clearTimeout(timer.current)
    }
  }, [])

  // 大屏监听
  useEffect(() => {
    // 视频画板resize和可画状态
    setTimeout(() => {
      // console.log(bigWin, winRef.current)
      winRef.current.forEach((v) => {
        v.board._resize()
        if (v.index === bigWin && !bigTeaAScreen) {
          !penState && v.board.setConf({ tool: 1 })
        } else {
          v.board.setConf({ tool: 0 })
        }
      })
    }, 350)
  }, [bigWin, bigTeaAScreen, videoLiveTea, penState])

  // 发送画线
  const emitArtDrawLine = useCallback((lineData: Lines) => {
    rtmClient.sendMessage('ArtDrawLine', lineData)
  }, [])

  // 配置更新，用于鼠标样式
  const boardConf = useCallback((conf: Conf, id: string) => {
    setDraw((v) => ({ ...v, [id]: conf.tool }))
  }, [])

  // 远端音视频播放
  const play = useCallback((mediaType: MediaType, remoteUser: RemoteUser) => {
    console.log('Teacher play', mediaType, remoteUser)
    const uid: string = remoteUser.uid.toString()
    const id = idDiffName[uid.slice(0, 2)]
    if (!id) {
      return
    }
    // if (id === 'justTeacher') {
    //   const { mainTeacherId } = getParams()
    //   setJustUser((v) => ({ ...v, [mainTeacherId]: true }))
    // }
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_${id}`) as HTMLElement
      ele.innerHTML = ''
      rtcClient.play(remoteUser.videoTrack, ele, { mirror: false, fit: 'contain', type: 'remote' })
      setVideoLiveTea((v) => ({ ...v, [id]: 1 }))
    } else {
      setAudioLive((v) => ({ ...v, [id]: true }))
    }
  }, [])

  // 远端音视频关闭
  const unplay = useCallback((mediaType: MediaType, remoteUser: RemoteUser) => {
    const uid: string = remoteUser.uid.toString()
    const id = idDiffName[uid.slice(0, 2)]
    if (!id) {
      return
    }
    // if (id === 'justTeacher') {
    //   const { mainTeacherId } = getParams()
    //   setJustUser((v) => ({ ...v, [mainTeacherId]: false }))
    //   justTeacherVideoBoard.clear(3)
    // }
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_${id}`) as HTMLElement
      ele.innerHTML = ''
      setVideoLiveTea((v) => ({ ...v, [id]: 0 }))
    } else {
      setAudioLive((v) => ({ ...v, [id]: false }))
    }
  }, [])

  // 麦震
  const volumeIndicator = useCallback((volumes: VolumeType[]) => {
    const vol: WinTeaName = {
      mainTeacher: 0,
      justTeacher: 0,
      viceTeacher: 0
    }
    volumes.forEach((v) => {
      const id: string = v.uid.toString()
      vol[idDiffName[id.slice(0, 2)]] = v.level
    })
    setVolumeLevel(vol)
  }, [])

  // 网络
  const networkQuality = useCallback((network: Network) => {
    const net: WinTeaName = {
      mainTeacher: 0,
      justTeacher: 0,
      viceTeacher: 0
    }
    const local = network.local
    const remote = network.remote
    Object.keys(remote).forEach((v) => {
      const id: string = v.toString()
      const remoteNet = remote[v]
      net[idDiffName[id.slice(0, 2)]] = remoteNet ? networkQualityEnum[remoteNet.downlinkNetworkQuality] : 0
    })
    setNetWorkLevel({ ...net })
  }, [])

  // 视频上台
  const goDesk = (id: WinTeaId, index: BigWin) => {
    // const inRoom = !!rtcClient.remoteVideoTrack.find((v) => {
    //   const uid: string = v.uid.toString()
    //   return id === idDiffName[uid.slice(0, 2)]
    // })
    // if (inRoom) {
    //   setBigWin(index)
    // } else {
    //   toast('视频未连接')
    // }
  }

  const bg = (id: WinTeaId) => {
    // 课间休息
    if (rest.state === 1) {
      return 'bg-tea-rest bg-cover'
    }
    // 有流
    if (videoLiveTea[id] === 1) {
      return ''
    }
    // 没有流
    if (videoLiveTea[id] === 0) {
      return 'bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003]'
    }
    // 关闭流
    if (videoLiveTea[id] === 2) {
      return 'bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003]'
    }
  }

  const hidden = (id: WinTeaId) => {
    // 存在老师just，老师主窗口隐藏
    if (id === 'mainTeacher' && justUser[params.mainTeacherId]) {
      return 'hidden'
    }
    // 不存在老师just，老师Just窗口隐藏
    if (id === 'justTeacher' && !justUser[params.mainTeacherId]) {
      return 'hidden'
    }
    return ''
  }

  // 监听just信息变化更新视频
  // useUpdateEffect(() => {
  //   setLocalJustStatus(justUser[params.mainTeacherId] || false)
  // }, [justUser])

  // useEffect(() => {
  //   const mainVideoTrack = rtcClient.remoteVideoTrack.find((v) => v.uid.toString().slice(0, 2) === '10')
  //   const justVideoTrack = rtcClient.remoteVideoTrack.find((v) => v.uid.toString().slice(0, 2) === '12')
  //   if (localJustStatus) {
  //     mainVideoTrack && unplay('video', mainVideoTrack)
  //     justVideoTrack && play('video', justVideoTrack)
  //   } else {
  //     mainVideoTrack && play('video', mainVideoTrack)
  //     justVideoTrack && unplay('video', justVideoTrack)
  //   }
  //   if (bigWin === 2 && !bigTeaAScreen) {
  //     if (localJustStatus) {
  //       mainTeacherVideoBoard.setConf({ tool: 0 })
  //       !penState && justTeacherVideoBoard.setConf({ tool: 1 })
  //     } else {
  //       !penState && mainTeacherVideoBoard.setConf({ tool: 1 })
  //       mainTeacherVideoBoard._resize()
  //       justTeacherVideoBoard.setConf({ tool: 0 })
  //     }
  //   }
  // }, [localJustStatus])
  const hiddenInView = roomWindowScale !== 'full'
  const styles = hiddenInView ? screenPosition : position

  return (
    <>
      {winRef.current.map((v) => (
        <div key={v.id} className={` ${hiddenInView ? 'w-full h-full' : 'w-full h-[22.5vh]'} ${hidden(v.id)}`}>
          <div className={`${bg(v.id)} bg-center ${draw[v.id] === 1 ? 'brush-border-box' : ''} ${styles[bigWin === v.index ? 1 : v.index]}`} onClick={() => goDesk(v.id, v.index)}>
            {videoLiveTea[v.id] ? (
              <div className={`absolute z-10 flex justify-between items-center w-full h-[2.1vh] px-[0.3vh] left-0 bottom-[0.3vh]`}>
                <NetWork level={netWorkLevel[v.id]} />
                {v.id === 'mainTeacher' ? (
                  <div className="relative w-[1.8vh] h-[2.6vh] flex justify-end items-center">
                    <img className="" src={!audioLive[v.id] ? microphoneImg : microphone1Img} alt="" />
                    <div className="flex items-end absolute rounded-[0.7vh] overflow-hidden left-[0.45vh] top-[0.2vh] w-[0.85vh] h-[1.52vh]">
                      <div style={{ height: `${volumeLevel[v.id]}%` }} className="w-full bg-gradient-to-b bg-[#92FF33]"></div>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
            <div id={`video_${v.id}`} className="w-full h-full"></div>
            <div id={`videoBoard_${v.id}`} className={`${draw[v.id] === 1 ? 'pen' : ''} ${videoLiveTea[v.id] !== 1 ? 'hidden' : ''} w-full h-full overflow-hidden absolute top-0 left-0`}></div>
          </div>
        </div>
      ))}
    </>
  )
}

export const TeacherTemp = () => {
  const [roomWindowScale, setRoomWindowScale] = useRecoilState(roomWindowScaleState)
  const hiddenInView = roomWindowScale !== 'full'

  return (
    <>
      <div className={hiddenInView ? 'w-full h-full' : 'w-full h-[22.5vh]'}>
        <div
          className={
            hiddenInView
              ? 'w-full h-full bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003] bg-center '
              : `bg-wait bg-wait-tips bg-[length:4vh] bg-no-repeat bg-[#0003] bg-center ${position[2]}`
          }
        ></div>
      </div>
    </>
  )
}
